import { getCookie } from '../../utils/cookie';

export function getSmartContent() {
    return new Promise(resolve => {
        window.PeeriusCallbacks.smartContent = cont => resolve(cont);
    });
}

export function getSmartRecommendations() {
    return new Promise(resolve => {
        window.PeeriusCallbacks.smartRecs = recs => resolve(recs);
    });
}

export const isDoNotTrack = () => {
    return getCookie('do_not_track');
};

export default {
    isDoNotTrack,
};
